import { ReactComponent as Vector9Icon } from "../../assets/images/vector_arrow.svg";
import IconButton from "../../ui/buttons/IconButton";
import tableStyles from "../../styles/components/MailsTable.module.css";
import cardStyles from "../../ui/cards/MailCards.module.css";
import styles from "../../styles/components/MailErrorsTable.module.css";

const ERROR_TABLE_COLUMNS =
  "160px minmax(16px,1fr) 220px minmax(16px,1fr) 140px minmax(16px,1fr) 150px minmax(16px,1fr) 40px minmax(16px,1fr) minmax(200px,320px)";

const ERROR_TABLE_HEADERS = [
  { label: "Lead", column: "1" },
  { label: "Asunto", column: "3" },
  { label: "Casilla", column: "5" },
  { label: "Template Group", column: "7" },
  { label: "#", column: "9" },
  { label: "Motivo del error", column: "11" },
];

function HeaderCell({ children, column }) {
  return (
    <div
      style={{
        gridColumn: column,
        textAlign: "center",
        color: "var(--color-text-text-primary)",
        fontSize: 14,
        fontFamily: "DM Sans",
        fontWeight: 500,
        lineHeight: "17px",
        minWidth: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {children}
    </div>
  );
}

function MailErrorRow({ errorRow, onOpenMail }) {
  const casillaName =
    errorRow?.responsible?.name || errorRow?.responsible?.email || "-";

  return (
    <div className={tableStyles.rowWrapper}>
      <div className={cardStyles.row}>
        <div
          className={cardStyles.itemCard}
          style={{
            background: "var(--surface-tertiary)",
            gridTemplateColumns: ERROR_TABLE_COLUMNS,
          }}
        >
          <div className={cardStyles.itemText} style={{ gridColumn: 1 }}>
            {errorRow?.lead?.name ?? "-"}
          </div>
          <div className={cardStyles.itemText} style={{ gridColumn: 3 }}>
            {errorRow?.subject ?? "-"}
          </div>
          <div
            style={{
              gridColumn: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 0,
            }}
          >
            <div className={cardStyles.tag}>
              <div className={cardStyles.tagText}>{casillaName}</div>
            </div>
          </div>
          <div className={cardStyles.itemText} style={{ gridColumn: 7 }}>
            {errorRow?.template_group?.name ?? "-"}
          </div>
          <div className={cardStyles.itemText} style={{ gridColumn: 9 }}>
            {errorRow?.send_number ?? "-"}
          </div>
          <div
            className={`${cardStyles.itemText} ${styles.errorMessageCell}`}
            style={{ gridColumn: 11 }}
            title={errorRow?.error_message ?? ""}
          >
            {errorRow?.error_message ?? "-"}
          </div>
        </div>

        <div className={cardStyles.actionWrap}>
          <IconButton
            icon={<Vector9Icon />}
            size="md"
            iconSize={14}
            onClick={(event) => {
              event.stopPropagation();
              onOpenMail?.(errorRow);
            }}
            aria-label="Abrir mail"
            className={cardStyles.iconBtn}
            style={{ background: "var(--surface-tertiary)" }}
          />
        </div>
      </div>
    </div>
  );
}

function MailErrorsTable({ rows = [], onOpenMail, hasActiveSearch = false }) {
  if (!rows.length) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyTitle}>
          {hasActiveSearch
            ? "No hay resultados para la búsqueda"
            : "No existen mails con errores de envío."}
        </div>
        <div className={styles.emptyDesc}>
          {hasActiveSearch
            ? "Probá con otros términos u otros filtros."
            : "Cuando el envío de un mail falle, acá vas a ver el motivo y su información."}
        </div>
      </div>
    );
  }

  return (
    <div className={tableStyles.mailsTableContainer}>
      <div className={tableStyles.mailsTable}>
        <div className={tableStyles.headerContainer}>
          <div className={tableStyles.headerBody} style={{ padding: "0 24px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: ERROR_TABLE_COLUMNS,
                alignItems: "center",
                minWidth: 0,
              }}
            >
              {ERROR_TABLE_HEADERS.map((header) => (
                <HeaderCell key={header.column} column={header.column}>
                  {header.label}
                </HeaderCell>
              ))}
            </div>
          </div>

          <div className={tableStyles.headerActionSpacer} />
        </div>

        {rows.map((errorRow) => (
          <MailErrorRow
            key={`MailErrorRow${errorRow.id}`}
            errorRow={errorRow}
            onOpenMail={onOpenMail}
          />
        ))}
      </div>
    </div>
  );
}

export default MailErrorsTable;
